/* eslint-disable */

import lockScroll from '../__utils/lockScroll';
import headerHandler from './header';
import { header } from './header';
import {
	HEADER_ACTIVE_CLASS,
	HEADER_SUBNAV_CLASS,
	SUBNAV_ACTIVE_CLASS,
} from './header';

const { body } = document;
const SEARCH_ACTIVE_CLASS = 'search-modal-active';

const searchModal = {
	button: document.querySelectorAll( '.js-header-search-btn' ),
	modal: document.querySelector( '.js-header-search-modal' ),

	bindEvents() {
		[ ...this.button ].forEach( ( el ) =>
			el.addEventListener( 'click', () => this.toggleModal() ),
		);
	},

	toggleModal( preventOverlay = false ) {
		if ( header.classList.contains( SEARCH_ACTIVE_CLASS ) ) {
			if ( ! preventOverlay ) {
				lockScroll.unlock();
				body.classList.remove( 'overlayed' );
			}
			header.classList.remove( SEARCH_ACTIVE_CLASS );
		} else {
			// close mobile header if open
			if ( header.classList.contains( HEADER_ACTIVE_CLASS ) ) {
				headerHandler.toggleNav( false );
			} else if ( header.classList.contains( HEADER_SUBNAV_CLASS ) ) {
				headerHandler.parentLinks.forEach( ( el ) =>
					el.classList.remove( SUBNAV_ACTIVE_CLASS ),
				);
				header.classList.remove( HEADER_SUBNAV_CLASS );
			}

			header.classList.add( SEARCH_ACTIVE_CLASS );

			lockScroll.lock();
			body.classList.add( 'overlayed' );
		}
	},

	hideOutSideClick( e ) {
		if ( ! this.modal ) {
			return;
		}
		if (
			( header.classList.contains( SEARCH_ACTIVE_CLASS ) &&
                ! [ ...this.button ].includes( e.target ) &&
                ! this.modal.contains( e.target ) ) ||
            e.target === this.modal
		) {
			const overlayBool =
                [ ...headerHandler.parentLinks ].includes( e.target ) || false;
			this.toggleModal( overlayBool );
		}
	},

	init() {
		if ( ! this.modal ) {
			return;
		}
		this.bindEvents();
	},
};

export default searchModal;
/* eslint-enable */
